import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_wifi_power_state.js";
//#region src/kiosk_wifi_power_state_helper.ts
var kiosk_wifi_power_state_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(wifiPowerState) {
	switch (wifiPowerState) {
		case 0: return "Unknown";
		case 1: return "On";
		case 2: return "Off";
	}
}
//#endregion
export { kiosk_wifi_power_state_helper_exports, name };

//# sourceMappingURL=kiosk_wifi_power_state_helper.js.map